import { UserHelper } from 'view/helpers';

// Backwards-compatible wrappers around view/helpers user_helper

export function getPlan(userGroup) {
	return UserHelper.getPlanByUserGroup(userGroup);
}

export function isAdminUser(user) {
	return UserHelper.isAdminUser(user);
}
//numeric key is the 'user_group'
let userTypesByUserGroup = {
	1: 'Member',
	2: 'Admin',
	3: 'Client',
	4: 'Employee',
};

export function getUserType(userGroup) {
	if (!userGroup) {
		return null;
	}
	return userTypesByUserGroup[userGroup] || null;
}
